import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { SETTLEMENT_INFORMATION } from "@/shared/resource/constants";
import { SETTLEMENT } from "@/shared/resource/apis/endpoints";
import { dateTime } from "@/shared/utills/date";

export const useSettlementStore = defineStore("settlement", {
  state: () => ({
    settlements: [],
    totalSettlements: 0,
    settlementInformation: [...SETTLEMENT_INFORMATION],
  }),

  actions: {
    async addSettlement(payload) {
      const response = await api.post(SETTLEMENT.POST, payload);
      return response.data;
    },

    async updateSettlement(id, payload) {
      const response = await api.put(SETTLEMENT.UPDATE(id), payload);
      return response.data;
    },

    clearSettlements() {
      this.settlements = [];
      this.totalSettlements = 0;
    },

    async fetch({ page = 1, limit = 10, filters = {} }) {
      this.clearSettlements();

      const response = await api.get(SETTLEMENT.GET, {
        params: { page_no: page, limit, ...filters },
      });
      const data = response?.data?.data ?? [];

      const formattedSettlements = data.map((settlement) => {
        const bank = settlement.bank ?? {};

        return {
          id: settlement.settlement_id || "N/A",
          transactionId: settlement.transaction_id || null,
          operatorId: settlement.operator_id,
          operatorName: settlement.operator_name,
          createdAt: dateTime.formatDateTime(settlement.created_at),
          phoneNumber: settlement.phone_number ?? "N/A",
          busNumber: settlement.reg_no ?? "N/A",
          travelsName: settlement.travels_name ?? "N/A",
          accountNumber: bank.account_number ?? "N/A",
          referenceNumber: settlement.bank_reference_number ?? "-",
          amount: settlement.amount,
          remark: settlement.remark,
          bankDetails: bank,
          bookingDetails: settlement.booking_details ?? [],
          busId: settlement.bus_id,
          busName: settlement.travels_name,
          settlementStatus: settlement.settled_status ? "settled" : "pending",
        };
      });

      this.setSettlements(formattedSettlements, response?.data?.count ?? 0);
      this.setSettlementInformation(response?.data ?? {});
      return formattedSettlements;
    },

    async save(id, payload) {
      let response;
      if (id) {
        response = await this.updateSettlement(id, payload);
      } else {
        response = await this.addSettlement(payload);
      }
      return response;
    },

    setSettlements(settlements, total) {
      this.settlements = settlements;
      this.totalSettlements = total;
    },

    setSettlementInformation(info = {}) {
      this.settlementInformation[0].count = info.total_settlement ?? 0;
      this.settlementInformation[1].count = info.total_amount_settled ?? 0;
      this.settlementInformation[2].count = info.failed_settlements ?? 0;
    },
  },

  getters: {
    getSettlements: (state) => state.settlements,
    getSettlementInformation: (state) => state.settlementInformation,
    getTotalSettlements: (state) => state.totalSettlements,
  },
});
